export default __webpack_public_path__ + "static/media/11.e3cb37e3.jpg";